<template>
    <div
        :id="id"
        class="search-preferences--section__title"
    >
        <PtCheckbox
            v-model="fieldValue"
            @change="syncChange"
        >
            {{ $t(fieldConfig.label) }}
        </PtCheckbox>
        <ElPopover
            v-if="![SEARCH_TYPE.sequence, SEARCH_TYPE.short].includes(store.searchType)"
            placement="right"
            trigger="hover"
            :visible-arrow="false"
            :width="366"
            popper-class="bio-search-setting__popover"
        >
            <div class="preferences-propver__content">
                <p>{{ $t('Search.propver.Preferences.defaultAlgorithm') }}</p>
            </div>

            <PtIcon
                slot="reference"
                icon="SolidInfo"
            />
        </ElPopover>
    </div>
</template>

<script>
import Checkbox from 'element-ui/lib/checkbox';
import Popover from 'element-ui/lib/popover';
import PtIcon from '@patsnap-biz/icon';
import { FieldItemMixin } from './mixins';
import { SEARCH_TYPE } from '../constants';

export default {
    components: {
        ElPopover: Popover,
        PtCheckbox: Checkbox,
        PtIcon,
    },
    mixins: [FieldItemMixin],
    inject: ['store'],
    props: {
        fieldName: {
            type: String,
            default: 'automatic',
        },
    },
    computed: {
        SEARCH_TYPE() {
            return SEARCH_TYPE;
        },
    },
};
</script>
